import { useEffect, useState } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import logo from "../assets/img/website-logo's/image.png";
import navIcon1 from "../assets/img/nav-icon-linkedin.svg";
import navIcon2 from "../assets/img/resume-download-icon-2.svg";
import navIcon3 from "../assets/img/gitlab logo.png";
import {
  NAVBAR_SCROLL_THRESHOLD,
  scrollToSection,
  smoothScroll,
  initializeNavbarHeight,
} from "../utils/scrollConfig";
import "./NavBar.css";

const NavBar = () => {
  const [activeLink, setActiveLink] = useState("home");
  const [scrolled, setScrolled] = useState(false);
  const [navbarExpanded, setNavbarExpanded] = useState(false); // State to track navbar expansion

  // Initialize navbar height on mount
  useEffect(() => {
    initializeNavbarHeight();
  }, []);

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > NAVBAR_SCROLL_THRESHOLD || navbarExpanded) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", onScroll);

    // Immediately check on mount and when navbarExpanded changes
    onScroll();

    return () => window.removeEventListener("scroll", onScroll);
  }, [navbarExpanded]);

  useEffect(() => {
    const banner = document.getElementById("home");
    if (navbarExpanded) {
      banner.classList.add("shifted");
    } else {
      banner.classList.remove("shifted");
    }
  }, [navbarExpanded]); // Adjust banner when navbarExpanded changes

  const onUpdateActiveLink = (value) => (event) => {
    // Prevent the browser's default anchor-scroll — it reads the current
    // (still-shifted on mobile) layout and races against our JS scroll.
    if (event && typeof event.preventDefault === "function") {
      event.preventDefault();
    }
    setActiveLink(value);
    setNavbarExpanded(false); // Collapse the navbar
    scrollToSection(value);
  };

  const scrollToTop = (event) => {
    event.preventDefault();
    setNavbarExpanded(false); // Collapse the navbar first
    setActiveLink("home");
    // Use custom smooth scroll with same easing as other sections
    smoothScroll(0);
  };

  return (
    <Navbar
      expand="lg"
      className={scrolled ? "scrolled" : ""}
      expanded={navbarExpanded}
      onToggle={(expanded) => setNavbarExpanded(expanded)} // Handle navbar toggle
    >
      <Container>
        <Navbar.Brand href="#home" onClick={scrollToTop}>
          <img src={logo} alt="MyPortfolio" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav">
          <span className="navbar-toggler-icon"></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link
              href="#home"
              className={
                activeLink === "home" ? "active navbar-link" : "navbar-link"
              }
              onClick={scrollToTop}
            >
              Home
            </Nav.Link>
            <Nav.Link
              href="#services"
              className={
                activeLink === "services" ? "active navbar-link" : "navbar-link"
              }
              onClick={onUpdateActiveLink("services")}
            >
              Services
            </Nav.Link>

            <Nav.Link
              href="#experience"
              className={
                activeLink === "experience"
                  ? "active navbar-link"
                  : "navbar-link"
              }
              onClick={onUpdateActiveLink("experience")}
            >
              Experience
            </Nav.Link>

            <Nav.Link
              href="#projects"
              className={
                activeLink === "projects" ? "active navbar-link" : "navbar-link"
              }
              onClick={onUpdateActiveLink("projects")}
            >
              Projects
            </Nav.Link>

            <Nav.Link
              href="#availability"
              className={
                activeLink === "availability"
                  ? "active navbar-link"
                  : "navbar-link"
              }
              onClick={onUpdateActiveLink("availability")}
            >
              Availability
            </Nav.Link>
          </Nav>
          <span className="navbar-text">
            <div className="social-icon">
              <a
                href="https://www.linkedin.com/in/henri-vandeputte-83ba45215/"
                aria-label="LinkedIn profile"
                rel="noopener noreferrer"
                target="_blank"
              >
                <img src={navIcon1} alt="LinkedIn" />
              </a>
              <a
                href="/assets/CV_Henri-Vandeputte-20260528.pdf"
                download="CV_Henri-Vandeputte_2026-05-28.pdf"
                aria-label="Download CV"
              >
                <img src={navIcon2} alt="Download CV" />
              </a>
              <a
                href="https://github.com/HenriVandeputte"
                aria-label="GitHub profile"
                rel="noopener noreferrer"
                target="_blank"
              >
                <img src={navIcon3} alt="GitHub" className="gitlab-icon" />
              </a>
            </div>
            <button
              className="vvd"
              onClick={onUpdateActiveLink("connect")}
            >
              {" "}
              <span> Let's Connect </span>{" "}
            </button>
          </span>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavBar;
